import React from 'react';
import PropTypes from 'prop-types';

import { FileThumbnail } from '@febos-io/design';

const formikInputFileDropZoneThumb = {
  display: 'block',
  borderRadius: 2,
  marginBottom: 8,
  marginRight: 8,
  minHeight: 100,
  minWidth: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'contents',
  minWidth: 100,
  minHeight: 100,
  overflow: 'hidden',
  textAlign: 'center'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

export function FormikInputFileDropZoneThumb({
  preview,
  maxHeight = '500px'
}) {
  return (
    <div style={formikInputFileDropZoneThumb} key={preview}>
      {preview ? (
        <div style={thumbInner} title={preview}>
          <img src={preview} style={{ ...img, maxHeight: maxHeight }} alt={preview} />
        </div>
      ) : (
        <div style={thumbInner}>
          <FileThumbnail />
        </div>
      )}
    </div>
  );
}

FormikInputFileDropZoneThumb.propTypes = {
  preview: PropTypes.string.isRequired,
  maxHeight: PropTypes.string
};

export default FormikInputFileDropZoneThumb;
